import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion as MuiAccordion,
  AccordionDetails as MuiAccordionDetails,
  AccordionSummary as MuiAccordionSummary,
  Typography,
  styled,
} from "@mui/material";
import { ReactElement, ReactNode } from "react";

import theme, { palette } from "~frontend/theme";

const Accordion = styled(MuiAccordion)({
  padding: 0,
  margin: 0,
  border: "none",
  backgroundColor: palette.lightestGray,
  "& .Mui-expanded": {
    minHeight: "auto",
  },
  "& .MuiAccordionSummary-root.Mui-expanded": {
    minHeight: "auto",
    margin: 0,
  },
  "& .MuiAccordionSummary-content.Mui-expanded": {
    minHeight: "auto",
    margin: 0,
  },
});

const AccordionDetails = styled(MuiAccordionDetails)({
  padding: `0 ${theme.spacing(3)} ${theme.spacing(3)} `,
  backgroundColor: palette.lightestGray,
});

const AccordionSummary = styled(MuiAccordionSummary)({
  padding: theme.spacing(3),
  margin: 0,
  minHeight: "auto",
  "& .MuiSvgIcon-root": {
    width: "1em",
    height: "1em",
    marginRight: "15px",
  },
  "& > .MuiAccordionSummary-content": {
    margin: 0,
    padding: 0,
  },
  "& .Mui-expanded": {
    minHeight: "auto",
    margin: 0,
    padding: 0,
  },
});

export default function ContactSourceAccordion({
  label,
  expanded,
  setExpanded,
  children,
}: {
  label: ReactNode;
  expanded: boolean;
  setExpanded?: (expanded: boolean) => void;
  children: ReactElement;
}): ReactElement {
  return (
    <Accordion square={true} expanded={expanded}>
      <AccordionSummary
        expandIcon={
          setExpanded ? (
            <ExpandMoreIcon
              sx={{ color: palette.navy, marginLeft: theme.spacing(1) }}
            />
          ) : null
        }
        onClick={() => {
          if (setExpanded) {
            setExpanded(!expanded);
          }
        }}
      >
        <Typography variant="body1Bold">{label}</Typography>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
}
